import { render, staticRenderFns } from "./MensajeForm.vue?vue&type=template&id=6010ac20&scoped=true&"
import script from "./MensajeForm.vue?vue&type=script&lang=ts&"
export * from "./MensajeForm.vue?vue&type=script&lang=ts&"
import style0 from "./MensajeForm.vue?vue&type=style&index=0&id=6010ac20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6010ac20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6010ac20', component.options)
    } else {
      api.reload('6010ac20', component.options)
    }
    module.hot.accept("./MensajeForm.vue?vue&type=template&id=6010ac20&scoped=true&", function () {
      api.rerender('6010ac20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Mensaje/MensajeForm.vue"
export default component.exports